import { render, staticRenderFns } from "./PiniaExampleView.vue?vue&type=template&id=10ad757e&scoped=true&"
import script from "./PiniaExampleView.vue?vue&type=script&lang=js&"
export * from "./PiniaExampleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ad757e",
  null
  
)

export default component.exports